module.exports = __webpack_public_path__ + "static/media/Oceans-hat.76882643.jpg";